import React, { useEffect } from "react";
import { validateForHeatMap } from "../apiclients/streamsapi_bridge";

function HeatMapValidation() {
  const validateHeatMap = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const authkey = urlParams.get("heatmap_auth_key");
    if (authkey) {
      sendAuthKeyValidationRequest(authkey);
    }
  };

  useEffect(() => {
    validateHeatMap();
  }, []);
}

const sendAuthKeyValidationRequest = async (authkey) => {
  let reqInfo = {};
  console.log("sendAuthKeyLoginRequest : " + authkey);
  reqInfo = await validateForHeatMap(authkey);
  if (!reqInfo) {
    window.location.href = "/pageNotFound";
  }
  let respInfo = await reqInfo.json();
  console.log(respInfo);
  if (reqInfo.status == 200) {
    setUserSession(respInfo);
    window.location.href = "/heatmap/view-info";
  } else {
    window.location.href = "/pageNotFound";
  }
};

function setUserSession(userInfo) {
  sessionStorage.setItem("heatmaptoken", userInfo.heatmap_token);
}

export default HeatMapValidation;
